function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 20,
  fill: "none"
});

var SvgSpin = function SvgSpin(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 50 50"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/spin.7ed45e8d.svg";
export { SvgSpin as ReactComponent };